import { render, staticRenderFns } from "./UsersTransfer.vue?vue&type=template&id=d1930762&scoped=true&"
import script from "./UsersTransfer.vue?vue&type=script&lang=js&"
export * from "./UsersTransfer.vue?vue&type=script&lang=js&"
import style0 from "./UsersTransfer.vue?vue&type=style&index=0&id=d1930762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1930762",
  null
  
)

export default component.exports